var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBell = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 2.5v.838c3.236.54 5.714 3.484 5.714 7.037v1.566c0 2.128.692 4.195 1.955 5.859l.665.872c.26.337.308.801.13 1.19-.179.39-.554.638-.964.638H4.07a1.07 1.07 0 0 1-.965-.637 1.172 1.172 0 0 1 .129-1.191L3.9 17.8a9.687 9.687 0 0 0 1.957-5.86v-1.565c0-3.553 2.478-6.497 5.715-7.037V2.5c0-.828.638-1.5 1.429-1.5.79 0 1.428.672 1.428 1.5zm-1.787 3C10.081 5.5 8 7.684 8 10.375v1.566c0 2.245-.62 4.434-1.772 6.309h13.545a12.067 12.067 0 0 1-1.772-6.31v-1.565c0-2.69-2.08-4.875-4.643-4.875h-.715zM15.858 22c0 .755-.3 1.56-.835 2.123A2.86 2.86 0 0 1 13 25a2.79 2.79 0 0 1-2.023-.877c-.536-.562-.835-1.368-.835-2.123h5.715z",
    fill: "#1A202C",
    fillRule: "evenodd"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.d8c8e24a.svg";
export { ForwardRef as ReactComponent };